var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bottom d-flex align-center pl-5"},_vm._l((_vm.options),function(option,index){return _c('div',{key:'option_' + index,class:[
      'menu-item d-flex',
      option.route === _vm.currentRouteName ? 'active' : '',
      option.disabled ? 'disabled' : ''
    ],on:{"click":function($event){return _vm.goToRoute(option)}}},[_c('span',[_vm._v(_vm._s(option.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }